import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllProvincesApi = async(reqBody) => {  
  return await axios.post(endPoints.province, reqBody);  
};
